/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from 'react';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { INewobjectCategoryForListPresenterSchema } from '../../../repositories/countryside-search/entities/newobject_category/NewobjectCategoryForListPresenterSchema';
import { INewobjectCategorySetForListPresenterSchema } from '../../../repositories/countryside-search/entities/newobject_category/NewobjectCategorySetForListPresenterSchema';
import { rangePrice, getAreaBlock } from '../../../utils';
import * as styles from './object.css';

export interface IMobileListItemObjectProps {
  object?: INewobjectCategoryForListPresenterSchema | null;
  objectType: keyof INewobjectCategorySetForListPresenterSchema;
  onSale: number;
  hidePrice?: boolean;
  onClickLink: (offersLink: string, objectType?: string) => (e: React.MouseEvent) => void;
}

export const MobileListItemObject = ({
  object,
  objectType,
  onSale,
  onClickLink,
  hidePrice,
}: IMobileListItemObjectProps) => {
  if (!object) {
    return null;
  }
  const { areaMin, areaMax, priceMin, priceMax, seo } = object;
  const areaBlock = getAreaBlock(areaMin!, areaMax!, objectType);
  const showLink = Boolean(onSale && seo && seo.url);
  const customProps = Object.assign(
    {},
    showLink &&
      !!seo && {
        onClick: onClickLink(seo.url as string, objectType),
        href: seo.url as string,
      },
  );
  const Tag = showLink ? 'a' : 'div';

  return (
    <Tag className={styles['container']} {...customProps}>
      <UIText1 color={showLink ? 'primary_100' : 'black_100'}>
        <div className={styles['title']}>
          <span>{areaBlock}</span>
          <span>{!!onSale && onSale}</span>
        </div>
      </UIText1>
      {!hidePrice && <UIText2 color="gray60_100">{rangePrice(+(priceMin || 0), +(priceMax || 0))}</UIText2>}
    </Tag>
  );
};
